import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-brand">
          Backup Manager
        </Link>
        
        <div className="navbar-menu">
          <Link to="/dashboard" className="navbar-link">Dashboard</Link>
          <Link to="/installations" className="navbar-link">Installations</Link>
          <Link to="/backup-logs" className="navbar-link">Backup Logs</Link>
          {/* {user.role === 'super_admin' && (
            <Link to="/register-admin" className="navbar-link">Add Admin</Link>
          )} */}
        </div>

        <div className="navbar-user">
          <span className="navbar-username">{user.username}</span>
          {/* <span className="navbar-role">{user.role}</span> */}
          <button onClick={handleLogout} className="navbar-logout">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;